import React, {
  useEffect,
  useState,
  useMemo,
  useRef,
  useCallback,
} from "react";
import styles from "./index.module.less";
import { TreeSelect, Upload } from "antd";
import { handleDownFile } from "@/services/manage";
import config from "@/config/env";
import { isSubmissionClosed } from "@/utils";
import {
  Iconsvg,
  InputField,
  ButtonField,
  SelectField,
  TextareaField,
  Combobox,
  ComboboxSuggestion,
} from "@wk/components-react16";
import { useUser } from "@/utils/UserContext";
import {
  getDictIdByCode,
  getDictListById,
  getKsDict,
  addActivity,
  editActivity,
  checkDict,
  addDictItem,
} from "@/services/history";
import {
  getPlayerDetail,
  getCode,
  verifySmsCode,
  editUser,
  addUser,
} from "@/services/user";

import { cloneDeep } from "lodash-es";
import ModalConfirm from "../../player/modal";
import AddYyModal from "../../player/modal/addYy";
import { useNavigate } from "react-router-dom";
import RViewerJS from "viewerjs-react";
import "viewerjs/dist/viewer.css";
import QRCode from "qrcode";

const step = [
  {
    label: "填写作品信息",
    labelId: "1",
  },
  {
    label: "作品上传",
    labelId: "2",
  },
  {
    label: "填写作者信息",
    labelId: "3",
  },
];
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
const phoneRegex = /^1[3-9]\d{9}$/;

const AddSubmission = () => {
  const { user, set } = useUser();
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [stepActive, setStepActive] = useState("1");
  const [caseInformation, setCaseInformation] = useState({ imgUrl: [] });
  const [alList, setAlList] = useState([]);
  const [yyList, setYyList] = useState([]);
  const [ksList, setKsList] = useState([]);
  const [zcList, setZcList] = useState([]);
  const [isAddSecondUser, setIsAddSecondUser] = useState(false);
  const [fileList, setFileList] = useState([]);

  const [isVerifyLoading, setIsVerifyLoading] = useState(false);
  const [isVerifySecondPhone, setIsVerifySecondPhone] = useState(false);

  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isCodeOpen, setIsCodeOpen] = useState(false);
  const [second, setSecond] = useState(0);
  const [isVerifyError, setIsVerifyError] = useState(false);

  const [firstCode, setFirstCode] = useState("");
  const [secondCode, setSecondCode] = useState("");
  const [thirdCode, setThirdCode] = useState("");
  const [forthCode, setForthCode] = useState("");

  const codeNumFirstRef = useRef(null);
  const codeNumSecondRef = useRef(null);
  const codeNumThirdRef = useRef(null);
  const codeNumForthRef = useRef(null);

  const [isUpToDaUserOpen, setIsUpToDaUserOpen] = useState(false);
  const [isUploadOpen, setIsUploadOpen] = useState(false);
  const [uploadErrorText, setUploadErrorText] = useState("");

  const [secondUserInfo, setSecondUserInfo] = useState({});
  const [isQrCodeOpen, setIsQrCodeOpen] = useState(false);
  // 下载
  const [isdownloadImg, setIsdownloadImg] = useState(false);

  const [isSaveOpen, setIsSaveOpen] = useState(false);
  const [filePropsAction, setFilePropsAction] = useState("");
  const [qrCodeUrl, setQrCodeUrl] = useState("");

  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageText, setMessageText] = useState("");

  // 作品名称
  const [nameStatus, setNameStatus] = useState("none");
  const nameErrorText = useMemo(() => {
    if (nameStatus === "none") {
      return [];
    }

    if (!caseInformation?.name) {
      return [{ label: "请输入作品名称", labelId: "1" }];
    }

    return [];
  }, [nameStatus, caseInformation?.name]);

  // 案例类型
  const [alStatus, setAlStatus] = useState("none");
  const alErrorText = useMemo(() => {
    if (alStatus === "none") {
      return [];
    }

    if (!caseInformation?.caseType) {
      return [{ label: "请选择案例类型", labelId: "1" }];
    }

    return [];
  }, [alStatus, caseInformation?.caseType]);

  // 机构
  const [hospitalStatus, setHospitalStatus] = useState("none");
  const hospitalErrorText = useMemo(() => {
    if (hospitalStatus === "none") {
      return [];
    }

    if (!caseInformation?.institution) {
      return [{ label: "请选择机构", labelId: "1" }];
    }

    return [];
  }, [hospitalStatus, caseInformation?.institution]);

  const [keshiStatus, setKeshiStatus] = useState(false);

  // 作品简介
  const [introductionStatus, setIntroductionStatus] = useState("none");
  const introductionErrorText = useMemo(() => {
    if (introductionStatus === "none") {
      return [];
    }

    if (!caseInformation?.description) {
      return [{ label: "请输入内容", labelId: "1" }];
    }

    return [];
  }, [introductionStatus, caseInformation?.description]);

  // 作者名称
  const [userNameStatus, setUserNameStatus] = useState("none");
  const usernameErrorText = useMemo(() => {
    if (userNameStatus === "none") {
      return [];
    }
    if (!userInfo?.userName) {
      return [{ label: "请输入选手姓名", labelId: "1" }];
    }

    if (userInfo?.userName.length < 2) {
      return [{ label: "请输入至少2个字符", labelId: "2" }];
    }

    return [];
  }, [userNameStatus, userInfo?.userName]);

  // 邮箱
  const [emailStatus, setEmailStatus] = useState("none");
  const emailErrorText = useMemo(() => {
    if (emailStatus === "none") {
      return [];
    }

    if (!userInfo?.email) {
      return [{ label: "请输入邮箱", labelId: "1" }];
    }

    if (userInfo?.email.length < 6) {
      return [{ label: "请输入至少6个字符", labelId: "2" }];
    }

    if (!emailRegex.test(userInfo?.email)) {
      return [{ label: "请输入正确的邮箱地址", labelId: "3" }];
    }

    return [];
  }, [emailStatus, userInfo?.email]);

  // 第二作者手机号
  const [secondPhoneStatus, setSecondPhoneStatus] = useState("none");
  const secondPhoneErrorText = useMemo(() => {
    if (secondPhoneStatus === "none") {
      return [];
    }

    if (!secondUserInfo?.secondPhone && secondUserInfo?.secondUserName) {
      return [{ label: "请输入手机号", labelId: "1" }];
    }

    if (!phoneRegex.test(secondUserInfo?.secondPhone)) {
      return [{ label: "请输入正确的手机号", labelId: "2" }];
    }

    if (secondUserInfo?.secondPhone === userInfo?.phone) {
      return [{ label: "手机号不能与第一作者相同", labelId: "3" }];
    }

    return [];
  }, [
    userInfo?.phone,
    secondPhoneStatus,
    secondUserInfo?.secondPhone,
    secondUserInfo?.secondUserName,
  ]);

  // 第二作者名称
  const [secondUserNameStatus, setSecondUserNameStatus] = useState("none");
  const secondUserNameErrorText = useMemo(() => {
    if (secondUserNameStatus === "none") {
      return [];
    }
    if (!secondUserInfo?.secondUserName && secondUserInfo?.secondPhone) {
      return [{ label: "请输入选手姓名", labelId: "1" }];
    }
    if (secondUserInfo?.secondUserName.length < 2) {
      return [{ label: "请输入至少2个字符", labelId: "2" }];
    }
  }, [
    secondUserNameStatus,
    secondUserInfo?.secondPhone,
    secondUserInfo?.secondUserName,
  ]);

  const getCaseTypeDict = async (code) => {
    try {
      const resList = await getDictIdByCode({ code });
      const id = resList?.result?.records[0]?.id || "";
      const itemList = await getDictListById({ dictId: id, pageSize: -1 });
      return itemList?.result?.records || [];
    } catch (error) {
      return [];
    }
  };

  const getAlList = async () => {
    const zcList = await getCaseTypeDict("al");
    setAlList(zcList);
  };
  const getYyList = async (value) => {
    const zcList = await getCaseTypeDict("yy");
    setYyList(zcList);
    if (value) {
      let itemFind = zcList.find((item) => {
        return item?.itemValue === value;
      });
      if (itemFind) {
        if (stepActive === "1") {
          onComboboxValueChange(itemFind);
        }
        if (stepActive === "3") {
          setUserInfo((prev) => {
            return {
              ...prev,
              hospital: itemFind?.id,
            };
          });
        }
      }
    }
  };
  const getZcList = async () => {
    const zcList = await getCaseTypeDict("zc");
    setZcList(zcList);
  };

  const delText = useMemo(() => {
    if (!secondUserInfo?.secondPhone) {
      return "";
    }
    return `${secondUserInfo?.secondPhone.slice(
      0,
      3
    )}****${secondUserInfo?.secondPhone.slice(
      secondUserInfo?.secondPhone.length - 4
    )}`;
  }, [secondUserInfo?.secondPhone]);

  const qrCodeText = useMemo(() => {
    return `${window.location.origin}/activation?phone=${
      secondUserInfo?.secondPhone || ""
    }`;
  }, [secondUserInfo?.secondPhone]);

  const getSecondUserInfo = async () => {
    if (!secondUserInfo?.secondPhone) {
      return;
    }
    if (!phoneRegex.test(secondUserInfo?.secondPhone)) {
      return;
    }
    if (secondUserInfo?.secondPhone === userInfo?.phone) {
      return;
    }

    const res = await getPlayerDetail(secondUserInfo?.secondPhone);
    if (res.code === 200) {
      // setCaseInformation({
      //   ...caseInformation,
      //   secondUserName: res?.result?.current?.userName || "",
      // });
      setSecondUserInfo({
        ...secondUserInfo,
        secondUserName:
          res?.result?.current?.userName ||
          secondUserInfo?.secondUserName ||
          "",
      });
    }
  };

  const next = (step) => {
    if (step === "1") {
      add();
    } else if (step === "2") {
      nextStepThree();
    } else if (step === "3") {
      submit();
    }
  };

  // 新增案例/编辑案例
  const add = async () => {
    if (!caseInformation?.name) {
      setNameStatus("error");
      return;
    }
    if (!caseInformation?.caseType) {
      setAlStatus("error");
      return;
    }
    if (!caseInformation?.institution) {
      setHospitalStatus("error");
      return;
    }
    if (!caseInformation?.dept) {
      setKeshiStatus(true);
      return;
    }
    if (!caseInformation?.description) {
      setIntroductionStatus("error");
      return;
    }

    const cloneCaseInformation = cloneDeep(caseInformation);

    cloneCaseInformation.dept = cloneCaseInformation?.dept?.join();
    cloneCaseInformation.imgUrl = cloneCaseInformation?.imgUrl?.join();
    // 获取当前年份
    cloneCaseInformation.belongYear = new Date().getFullYear().toString();
    setIsSubmitLoading(true);
    let res;
    try {
      if (caseInformation?.id) {
        res = await editActivity(cloneCaseInformation);
      } else {
        res = await addActivity(cloneCaseInformation);
      }

      if (res?.code === 200) {
        if (!caseInformation?.id) {
          setCaseInformation({
            ...caseInformation,
            id: res?.result,
          });
        }
        setStepActive("2");
      }
    } catch (error) {
      setIsSubmitLoading(false);
    }
    setIsSubmitLoading(false);
  };

  const nextStepThree = async () => {
    const cloneCaseInformation = cloneDeep(caseInformation);
    if (!cloneCaseInformation?.fileUrl) {
      setIsUploadOpen(true);
      setUploadErrorText("请上传作品附件");
      return;
    }

    if (
      !cloneCaseInformation?.imgUrl ||
      cloneCaseInformation?.imgUrl?.length < 1
    ) {
      setIsUploadOpen(true);
      setUploadErrorText("请上传图片");
      return;
    }

    cloneCaseInformation.dept = cloneCaseInformation?.dept?.join();
    cloneCaseInformation.imgUrl = cloneCaseInformation?.imgUrl?.join();
    console.log(cloneCaseInformation);

    setIsSubmitLoading(true);
    try {
      const res = await editActivity(cloneCaseInformation);

      if (res?.code === 200) {
        setStepActive("3");
      }
    } catch (error) {
      setIsSubmitLoading(false);
    }
    setIsSubmitLoading(false);
  };

  const verifyCode = async (
    valueFirst,
    valueSecond,
    valueThird,
    valueForth
  ) => {
    if (!valueFirst || !valueSecond || !valueThird || !valueForth) {
      return;
    }

    setIsVerifyLoading(true);
    try {
      const res = await verifySmsCode(
        `${valueFirst}${valueSecond}${valueThird}${valueForth}`,
        secondUserInfo?.secondPhone
      );
      if (res.code === 200) {
        setIsVerifySecondPhone(true);
        setIsCodeOpen(false);
        setFirstCode("");
        setSecondCode("");
        setThirdCode("");
        setForthCode("");
      }

      if (res?.code === 500) {
        setIsVerifyError(true);
        setIsVerifySecondPhone(false);
      }
    } catch (error) {
      setIsVerifyLoading(false);
    }
    setIsVerifyLoading(false);
  };
  // 比较第一作者与个人信息是否一致
  const compareUserInfo = () => {
    const cloneUser = cloneDeep(user);
    const cloneUserInfo = cloneDeep(userInfo);
    cloneUserInfo.keshi = cloneUserInfo?.keshi
      ? cloneUserInfo?.keshi?.join(",")
      : "";

    if (
      cloneUser?.userName != cloneUserInfo?.userName ||
      cloneUser?.hospital != cloneUserInfo?.hospital ||
      cloneUser?.keshi != cloneUserInfo?.keshi ||
      cloneUser?.zhicheng != cloneUserInfo?.zhicheng ||
      cloneUser?.email != cloneUserInfo?.email
    ) {
      return true;
    }

    return false;
  };
  const getSecondCode = async () => {
    setIsSubmitLoading(true);
    try {
      const res = await getCode(secondUserInfo?.secondPhone);
      // 开始倒计时
      let time = 60;
      setSecond(--time);
      let clearTimer = setInterval(() => {
        setSecond(--time);
        if (time < 1) {
          clearInterval(clearTimer);
        }
      }, 1000);
      if (res?.code === 200) {
        setIsCodeOpen(true);
        setTimeout(() => {
          codeNumFirstRef.current.focus();
        }, 1000);
      } else if (res?.code === 500) {
        setMessageText("短信验证码发送失败，请稍后重试");
        setIsMessageOpen(true);
      }
    } catch (error) {
      setIsSubmitLoading(false);
    }
    setIsSubmitLoading(false);
  };

  const submitAndOpenQrCode = async (isLeave = false) => {
    setIsSubmitLoading(true);
    try {
      const resDetail = await getPlayerDetail(secondUserInfo?.secondPhone);
      if (resDetail?.code === 200) {
        let secondUserKey;
        if (!resDetail?.result?.current) {
          const res = await addUser({
            userName: secondUserInfo?.secondUserName,
            phone: secondUserInfo?.secondPhone,
          });
          if (res?.code === 200) {
            secondUserKey = res?.result;
          }
        } else {
          secondUserKey = resDetail?.result?.current?.id;
        }
        setCaseInformation({
          ...caseInformation,
          secondUserKey: secondUserKey,
        });
        const cloneCaseInformation = cloneDeep(caseInformation);
        cloneCaseInformation.dept = cloneCaseInformation?.dept?.join();
        cloneCaseInformation.imgUrl = cloneCaseInformation?.imgUrl?.join();
        cloneCaseInformation.secondUserKey = secondUserKey;
        if (!isLeave) {
          cloneCaseInformation["commitStatus"] = "2";
        }

        const res = await editActivity(cloneCaseInformation);

        if (res?.code !== 200) {
          // 后端拦截（如投稿已截止）时提示错误信息
          setIsSubmitLoading(false);
          setMessageText(res?.message || "提交失败，请稍后重试");
          setIsMessageOpen(true);
          return;
        }

        if (!isLeave) {
          if (
            !resDetail?.result?.current ||
            resDetail?.result?.current?.status !== "1"
          ) {
            setIsQrCodeOpen(true);
          } else {
            navigate("/player/personalCases");
          }
        } else {
          setIsSaveOpen(false);
          navigate("/player/personalCases");
        }
      }
    } catch (error) {
      setIsSubmitLoading(false);
    }
    setIsSubmitLoading(false);
  };

  const UpToDateAndEdit = async () => {
    if (isVerifySecondPhone) {
      submitAndOpenQrCode();
    } else {
      editStatus();
    }
    const value = cloneDeep(userInfo);
    value?.keshi ? (value.keshi = value?.keshi.join()) : (value.keshi = "");
    if (!value?.id) return;
    const res = await editUser(value);
    if (res?.code === 200) {
      set(value);
    }
  };

  const editStatus = async (value) => {
    const cloneCaseInformation = value
      ? cloneDeep(value)
      : cloneDeep(caseInformation);
    console.log(cloneCaseInformation);

    cloneCaseInformation.dept = cloneCaseInformation?.dept?.join();
    cloneCaseInformation.imgUrl = cloneCaseInformation?.imgUrl?.join();

    setIsSubmitLoading(true);
    try {
      const res = await editActivity({
        ...cloneCaseInformation,
        commitStatus: "2",
      });

      if (res?.code === 200) {
        navigate("/player/personalCases");
      } else {
        // 后端拦截（如投稿已截止）时提示错误信息
        setMessageText(res?.message || "提交失败，请稍后重试");
        setIsMessageOpen(true);
      }
    } catch (error) {
      setIsSubmitLoading(false);
    }
    setIsSubmitLoading(false);
  };

  const submit = async () => {
    // 投稿截止后不允许提交案例
    if (isSubmissionClosed()) {
      setMessageText("投稿已截止，无法提交案例");
      setIsMessageOpen(true);
      return;
    }

    if (!userInfo?.userName || userInfo?.userName.length < 2) {
      setNameStatus("error");
      return;
    }
    if (
      !userInfo?.email ||
      userInfo?.email.length < 6 ||
      !emailRegex.test(userInfo?.email)
    ) {
      setEmailStatus("error");
      return;
    }

    if (isAddSecondUser) {
      if (!secondUserInfo?.secondPhone && secondUserInfo?.secondUserName) {
        setSecondPhoneStatus("error");
        return;
      }
      if (
        secondUserInfo?.secondPhone &&
        !phoneRegex.test(secondUserInfo?.secondPhone)
      ) {
        setSecondPhoneStatus("error");
        return;
      }
      if (secondUserInfo?.secondPhone === userInfo?.phone) {
        setSecondPhoneStatus("error");
        return;
      }

      if (!secondUserInfo?.secondUserName && secondUserInfo?.secondPhone) {
        setSecondUserNameStatus("error");
        return;
      }

      if (
        secondUserInfo?.secondPhone &&
        secondUserInfo?.secondUserName.length < 2
      ) {
        setSecondUserNameStatus("error");
        return;
      }
      if (secondUserInfo?.secondPhone) {
        if (isVerifySecondPhone) {
          const isUpdate = compareUserInfo();
          if (isUpdate) {
            setIsUpToDaUserOpen(true);
          } else {
            submitAndOpenQrCode();
          }
        } else {
          if (second < 1) {
            getSecondCode();
          } else {
            setIsCodeOpen(true);
          }
        }
      } else {
        setCaseInformation({
          ...caseInformation,
          secondUserKey: "",
        });
        const isUpdate = compareUserInfo();
        if (isUpdate) {
          setIsUpToDaUserOpen(true);
        } else {
          editStatus({
            ...caseInformation,
            secondUserKey: "",
          });
        }
      }
    } else {
      setCaseInformation({
        ...caseInformation,
        secondUserKey: "",
      });

      const isUpdate = compareUserInfo();
      if (isUpdate) {
        setIsUpToDaUserOpen(true);
      } else {
        editStatus({
          ...caseInformation,
          secondUserKey: "",
        });
      }
    }
  };

  const beforeFileUpload = (file) => {
    return new Promise((resolve, reject) => {
      // 校验文件是否为.pdf,.doc,.docx,.ppt,.pptx文件
      var testmsg =
        /^application\/(pdf|msword|vnd.openxmlformats-officedocument.wordprocessingml.document|vnd.openxmlformats-officedocument.presentationml.presentation|vnd.ms-powerpoint)$/.test(
          file.type
        );

      // 判断文件是否为.doc,.docx文件
      var word =
        /^application\/(msword|vnd.openxmlformats-officedocument.wordprocessingml.document)$/.test(
          file.type
        );

      // 判断文件是否为.ppt,.pptx文件
      var ppt =
        /^application\/(vnd.openxmlformats-officedocument.presentationml.presentation|vnd.ms-powerpoint)$/.test(
          file.type
        );

      if (word) {
        setFilePropsAction(`${config.apiBaseUrl}/tc/hosp/file/convertToPdf3`);
      } else if (ppt) {
        setFilePropsAction(`${config.apiBaseUrl}/tc/hosp/file/convertToPdf3`);
      } else {
        setFilePropsAction(`${config.apiBaseUrl}/tc/hosp/file/upload`);
      }

      const isLt100MB = file.size / 1024 / 1024 <= 100; //图片大小不超过100MB

      const isGt100KB = file.size / 1024 >= 100; // 文件大小不小于100KB

      if (!testmsg) {
        setIsUploadOpen(true);
        setUploadErrorText("请上传正确的文件格式");
        return reject(false);
      }
      if (!isLt100MB) {
        setIsUploadOpen(true);
        setUploadErrorText("文件大小不能超过100MB");
        return reject(false);
      }
      if (!isGt100KB) {
        setIsUploadOpen(true);
        setUploadErrorText("文件大小不能小于100KB");
        return reject(false);
      }
      return resolve(true);
    });
  };

  const beforeImgUpload = (file) => {
    return new Promise((resolve, reject) => {
      var testmsg = /^image\/(jpeg|png|jpg|svg|bmp)$/.test(file.type);
      const isLt20MB = file.size / 1024 / 1024 <= 20; //图片大小不超过20MB
      if (!testmsg) {
        setIsUploadOpen(true);
        setUploadErrorText("请上传正确的图片格式");
        return reject(false);
      }
      if (!isLt20MB) {
        setIsUploadOpen(true);
        setUploadErrorText("图片大小不能超过20MB");
        return reject(false);
      }
      return resolve(true);
    });
  };

  const fileProps = {
    accept: ".pdf,.doc,.docx,.ppt,.pptx",
    name: "file",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      // if (info.file.status !== "uploading") {
      //   console.log(info.file, info.fileList);
      // }

      if (isUploadOpen) {
        return;
      }

      setFileList(info.fileList);
      if (info.file.status === "done") {
        const res = info.file.response;
        if (res?.success) {
          setCaseInformation({
            ...caseInformation,
            fileUrl: info.file.response.message,
            fileName: info.file.name,
          });

          setFileList([
            {
              name: info.file.name,
              status: "done",
              url: info.file.response.message,
            },
          ]);
        } else {
          setIsUploadOpen(true);
          setUploadErrorText("文件上传失败");
          setFileList([]);
        }
      }

      if (info.file.status === "removed") {
        setCaseInformation({
          ...caseInformation,
          fileUrl: "",
          fileName: "",
        });
      }

      if (info.file.status === "error") {
        setIsUploadOpen(true);
        if (info.file.response) {
          setUploadErrorText("文件上传失败");
        } else {
          setUploadErrorText("上传超时，请稍后再试");
        }

        setFileList([]);
      }
    },
    beforeUpload: beforeFileUpload,
    fileList: fileList,
    maxCount: 1,
    // showUploadList: false,
  };

  const fileImgProps = {
    accept: ".jpg,.jpeg,.png,.gif,.bmp,.webp",
    // name: "file",
    action: `${config.apiBaseUrl}/tc/hosp/file/upload`,
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status === "done") {
        const res = info.file.response;
        if (res?.success) {
          let imgFile = res.message;
          const cloneCaseInformation = cloneDeep(caseInformation);
          cloneCaseInformation.imgUrl = cloneCaseInformation.imgUrl || [];
          cloneCaseInformation.imgUrl.push(imgFile);
          setCaseInformation(cloneCaseInformation);
        } else {
          setIsUploadOpen(true);
          setUploadErrorText("图片上传失败");
        }
      }
    },
    beforeUpload: beforeImgUpload,
    showUploadList: false,
  };

  // 复制
  const copyLink = (text) => {
    let textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  };

  const leaveFirst = () => {
    const value = cloneDeep(caseInformation);
    value.dept = value?.dept?.join();

    if (
      !value.name &&
      !value.caseType &&
      !value.institution &&
      !value.dept &&
      !value.description
    ) {
      navigate("/player/personalCases");
    } else {
      setIsSaveOpen(true);
    }
  };

  const leave = () => {
    if (stepActive === "1") {
      leaveFirst();
      return;
    }
    setIsSaveOpen(true);
  };

  const leaveSaveFirst = async () => {
    const cloneCaseInformation = cloneDeep(caseInformation);

    cloneCaseInformation.dept = cloneCaseInformation?.dept?.join();
    cloneCaseInformation.imgUrl = cloneCaseInformation?.imgUrl?.join();
    // 获取当前年份
    cloneCaseInformation.belongYear = new Date().getFullYear().toString();
    setIsSubmitLoading(true);
    let res;
    try {
      if (caseInformation?.id) {
        res = await editActivity(cloneCaseInformation);
      } else {
        res = await addActivity(cloneCaseInformation);
      }

      if (res?.code === 200) {
        setIsSaveOpen(false);
        navigate("/player/personalCases");
      }
    } catch (error) {
      setIsSubmitLoading(false);
    }
    setIsSubmitLoading(false);
  };

  const leaveSaveSecond = async () => {
    const cloneCaseInformation = cloneDeep(caseInformation);
    cloneCaseInformation.dept = cloneCaseInformation?.dept?.join();
    cloneCaseInformation.imgUrl = cloneCaseInformation?.imgUrl?.join();
    setIsSubmitLoading(true);
    try {
      const res = await editActivity(cloneCaseInformation);

      if (res?.code === 200) {
        setIsSaveOpen(false);
        navigate("/player/personalCases");
      }
    } catch (error) {
      setIsSubmitLoading(false);
    }
    setIsSubmitLoading(false);
  };

  const leaveSaveThird = async () => {
    const cloneCaseInformation = cloneDeep(caseInformation);
    if (!userInfo?.userName || userInfo?.userName.length < 2) {
      setNameStatus("error");
      return;
    }
    if (
      !userInfo?.email ||
      userInfo?.email.length < 6 ||
      !emailRegex.test(userInfo?.email)
    ) {
      setEmailStatus("error");
      return;
    }

    const isUpdate = compareUserInfo();

    if (isAddSecondUser) {
      if (!secondUserInfo?.secondPhone && secondUserInfo?.secondUserName) {
        setSecondPhoneStatus("error");
        return;
      }
      if (
        secondUserInfo?.secondPhone &&
        !phoneRegex.test(secondUserInfo?.secondPhone)
      ) {
        setSecondPhoneStatus("error");
        return;
      }
      if (secondUserInfo?.secondPhone === userInfo?.phone) {
        setSecondPhoneStatus("error");
        return;
      }

      if (!secondUserInfo?.secondUserName && secondUserInfo?.secondPhone) {
        setSecondUserNameStatus("error");
        return;
      }

      if (
        secondUserInfo?.secondPhone &&
        secondUserInfo?.secondUserName.length < 2
      ) {
        setSecondUserNameStatus("error");
        return;
      }
      if (secondUserInfo?.secondPhone) {
        if (isVerifySecondPhone) {
          submitAndOpenQrCode(true);
          if (isUpdate) {
            const value = cloneDeep(userInfo);
            value?.keshi
              ? (value.keshi = value?.keshi.join())
              : (value.keshi = "");
            if (!value?.id) return;
            const res = await editUser(value);
            if (res?.code === 200) {
              set(value);
            }
          }
        } else {
          if (second < 1) {
            getSecondCode();
          } else {
            setIsCodeOpen(true);
          }
        }
      } else {
        cloneCaseInformation.secondUserKey = "";
        if (isUpdate) {
          const value = cloneDeep(userInfo);
          value?.keshi
            ? (value.keshi = value?.keshi.join())
            : (value.keshi = "");
          if (!value?.id) return;
          const res = await editUser(value);
          if (res?.code === 200) {
            set(value);
          }
        }
        cloneCaseInformation.dept = cloneCaseInformation?.dept?.join();
        cloneCaseInformation.imgUrl = cloneCaseInformation?.imgUrl?.join();

        setIsSubmitLoading(true);
        try {
          const res = await editActivity(cloneCaseInformation);
          if (res?.code === 200) {
            setIsSaveOpen(false);
            navigate("/player/personalCases");
          }
        } catch (error) {
          setIsSubmitLoading(false);
        }
        setIsSubmitLoading(false);
      }
    } else {
      cloneCaseInformation.secondUserKey = "";

      if (isUpdate) {
        const value = cloneDeep(userInfo);
        value?.keshi ? (value.keshi = value?.keshi.join()) : (value.keshi = "");
        if (!value?.id) return;
        const res = await editUser(value);
        if (res?.code === 200) {
          set(value);
        }
      }
      cloneCaseInformation.dept = cloneCaseInformation?.dept?.join();
      cloneCaseInformation.imgUrl = cloneCaseInformation?.imgUrl?.join();

      setIsSubmitLoading(true);
      try {
        const res = await editActivity(cloneCaseInformation);
        if (res?.code === 200) {
          setIsSaveOpen(false);
          navigate("/player/personalCases");
        }
      } catch (error) {
        setIsSubmitLoading(false);
      }
      setIsSubmitLoading(false);
    }
  };

  const leaveSave = () => {
    if (stepActive === "1") {
      leaveSaveFirst();
    }

    if (stepActive === "2") {
      leaveSaveSecond();
    }

    if (stepActive === "3") {
      leaveSaveThird();
    }
  };

  const [isValueError, setIsValueError] = useState(false);
  const [isAddYyOpen, setIsAddYyOpen] = useState(false);
  const [isAddYyLoading, setIsAddYyLoading] = useState(false);
  const [isYyDropdownOpen, setIsYyDropdownOpen] = useState(false);
  const [yyComboboxValue, setYyComboboxValue] = useState({});
  const [yyComboboxInputValue, setYyComboboxInputValue] = useState("");

  const getFilteredOptions = useCallback(() => {
    const value = cloneDeep(yyComboboxInputValue);

    if (yyComboboxValue?.itemText === value) {
      return yyList;
    }

    const filteredOptions = yyList.filter((item) => {
      return item?.itemText.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });

    if (filteredOptions.length === 0) {
      return [{ itemText: `+ 添加机构 ${value}`, id: "create" }];
    }

    return filteredOptions;
  }, [yyComboboxInputValue, yyComboboxValue, yyList]);

  const onClear = () => {
    setYyComboboxInputValue("");
    // setYyComboboxValue({});
    // setUserInfo({ ...userInfo, hospital: "" });
  };

  const onInputClick = () => {
    setIsYyDropdownOpen(true);
  };

  const onComboboxValueChange = (e) => {
    setIsYyDropdownOpen(false);

    if (e?.id !== "create") {
      setYyComboboxInputValue(e?.itemText);
      setYyComboboxValue(e);
      setCaseInformation({
        ...caseInformation,
        institution: e?.id,
      });
      if (!e?.id) {
        setHospitalStatus("error");
      }
      setHospitalStatus("none");
    } else {
      setIsAddYyOpen(true);
    }
  };

  const onKey = (e) => {
    const { value } = e.target;
    setYyComboboxInputValue(value);
    if (value !== "") {
      setIsYyDropdownOpen(true);
    }
  };

  const [isYyUserDropdownOpen, setIsYyUserDropdownOpen] = useState(false);
  const [yyUserComboboxValue, setYyUserComboboxValue] = useState({});
  const [yyUserComboboxInputValue, setYyUserComboboxInputValue] = useState("");

  const getFilteredOptionsUser = useCallback(() => {
    const value = cloneDeep(yyUserComboboxInputValue);

    if (yyUserComboboxValue?.itemText === value) {
      return yyList;
    }

    const filteredOptions = yyList.filter((item) => {
      return item?.itemText.toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });

    if (filteredOptions.length === 0) {
      return [{ itemText: `+ 添加机构 ${value}`, id: "create" }];
    }

    return filteredOptions;
  }, [yyUserComboboxInputValue, yyUserComboboxValue, yyList]);

  const onUserClear = () => {
    setYyUserComboboxInputValue("");
  };

  const onUserInputClick = () => {
    setIsYyUserDropdownOpen(true);
  };

  const onUserComboboxValueChange = (e) => {
    setIsYyUserDropdownOpen(false);

    if (e?.id !== "create") {
      setYyUserComboboxInputValue(e?.itemText);
      setYyUserComboboxValue(e);
      setUserInfo({ ...userInfo, hospital: e?.id });
    } else {
      setIsAddYyOpen(true);
    }
  };

  const onUserKey = (e) => {
    const { value } = e.target;
    setYyUserComboboxInputValue(value);
    if (value !== "") {
      setIsYyUserDropdownOpen(true);
    }
  };

  const addYy = async (value, callBack) => {
    setIsAddYyLoading(true);

    try {
      const res = await getDictIdByCode({ code: "yy" });
      if (!res?.success || !res?.result?.records?.length) {
        setIsAddYyLoading(false);
        return;
      }

      const dictId = res?.result?.records[0]?.id;
      // const checkRes = await checkDict({ dictId, itemValue: value.value });
      // if (checkRes?.code !== 200) {
      //   setIsAddYyLoading(false);
      //   setIsValueError(true);
      //   return;
      // }

      const resAdd = await addDictItem({
        dictId,
        itemText: value.name,
        itemValue: value.value,
      });
      if (resAdd?.code === 200) {
        await getYyList(value.value);
        setIsAddYyOpen(false);
        callBack();
      }
    } catch (error) {
      setIsAddYyLoading(false);
    }

    setIsAddYyLoading(false);
  };

  useEffect(() => {
    getKsDict().then((res) => {
      setKsList(res.result || []);
    });

    getYyList();
    getAlList();
    getZcList();
  }, []);

  useEffect(() => {
    const value = cloneDeep(user);
    value?.keshi ? (value.keshi = value?.keshi.split(",")) : (value.keshi = []);

    setCaseInformation({
      ...caseInformation,
      firstUserKey: value?.id,
    });
    setUserInfo(value);
  }, [user]);

  useEffect(() => {
    const value = cloneDeep(userInfo);
    let itemFind = yyList.find((item) => {
      return item?.id === value?.hospital;
    });

    if (itemFind) {
      setYyUserComboboxValue(itemFind);
      setYyUserComboboxInputValue(itemFind?.itemText);
    }
  }, [userInfo, yyList]);

  useEffect(() => {
    verifyCode(firstCode, secondCode, thirdCode, forthCode);
  }, [firstCode, secondCode, thirdCode, forthCode]);

  useEffect(() => {
    if (isQrCodeOpen) {
      const text = qrCodeText;
      QRCode.toDataURL(text, function (error, url) {
        if (error) {
        } else {
          setQrCodeUrl(url);
        }
      });
    }
  }, [isQrCodeOpen, qrCodeText]);

  return (
    <div className={styles["addSubmission-box"]}>
      <div className="addSubmission-content">
        <div className="first">
          <div className="connector"></div>
          {step.map((item) => {
            return (
              <div
                className={item.labelId === stepActive ? "step active" : "step"}
                key={item.labelId}
              >
                <div className="step-circle">{item.labelId}</div>
                <span className="step-label">{item.label}</span>
              </div>
            );
          })}
        </div>

        <div className="second">
          {stepActive === "1"
            ? "作品基础信息"
            : stepActive === "2"
            ? "作品上传"
            : stepActive === "3" && "作者信息"}
        </div>

        {stepActive === "1" && (
          <div className="third step-content-first">
            <div className="flex">
              <InputField
                label="作品名称"
                indicator="required"
                status={nameStatus}
                errors={nameErrorText}
              >
                <input
                  type="text"
                  placeholder="请输入作品名称"
                  required
                  value={caseInformation?.name}
                  onChange={(e) => {
                    setCaseInformation({
                      ...caseInformation,
                      name: e.target.value,
                    });
                    if (!e.target.value) {
                      setNameStatus("error");
                      return;
                    }
                    setNameStatus("none");
                  }}
                  maxLength={100}
                />
              </InputField>

              <SelectField
                label="案例类型"
                indicator="required"
                status={alStatus}
                errors={alErrorText}
              >
                <select
                  value={caseInformation?.caseType || ""}
                  onChange={(e) => {
                    setCaseInformation({
                      ...caseInformation,
                      caseType: e.target.value,
                    });
                    if (!e.target.value) {
                      setAlStatus("error");
                      return;
                    }
                    setAlStatus("none");
                  }}
                >
                  <option disabled hidden value={""}>
                    请选择案例类型
                  </option>

                  {alList?.map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.itemText}
                      </option>
                    );
                  })}
                </select>
              </SelectField>
            </div>

            <div className="flex">
              {/* <SelectField
                label="机构"
                indicator="required"
                status={hospitalStatus}
                errors={hospitalErrorText}
              >
                <select
                  value={caseInformation?.institution || ""}
                  onChange={(e) => {
                    setCaseInformation({
                      ...caseInformation,
                      institution: e.target.value,
                    });
                    if (!e.target.value) {
                      setHospitalStatus("error");
                    }
                    setHospitalStatus("none");
                  }}
                >
                  <option disabled hidden value={""}>
                    请选择机构
                  </option>
                  {yyList.map((item) => {
                    return (
                      <option key={item.id} value={item.id}>
                        {item.itemText}
                      </option>
                    );
                  })}
                </select>
              </SelectField> */}

              <Combobox
                isOpen={isYyDropdownOpen}
                hasClearButton={isYyDropdownOpen && yyComboboxInputValue}
                onDropdownUserRequest={(event) => {
                  setIsYyDropdownOpen(event);
                  setYyComboboxInputValue(yyComboboxValue.itemText);
                }}
                onClearUserRequest={onClear}
                label="机构"
                indicator="required"
                status={hospitalStatus}
                errors={hospitalErrorText}
              >
                <input
                  placeholder="请选择机构"
                  value={yyComboboxInputValue}
                  onClick={onInputClick}
                  onInput={(event) => onKey(event)}
                  slot="comboboxInput"
                  maxLength={20}
                />
                {Object.values(getFilteredOptions()).map((item, idx) => {
                  return (
                    <React.Fragment key={item.id}>
                      <ComboboxSuggestion
                        isSelected={item.id === yyComboboxValue.id}
                        onItemClick={() => onComboboxValueChange(item)}
                        slot="comboboxSuggestion"
                      >
                        {item.itemText}
                      </ComboboxSuggestion>
                    </React.Fragment>
                  );
                })}
              </Combobox>

              <div className={keshiStatus ? "department error" : "department"}>
                <div className="header">
                  <span className="label">科室</span>
                  <div className="cg-field-required-indicator">
                    <span aria-hidden="true">*</span>
                  </div>
                </div>
                <TreeSelect
                  style={{ width: "100%" }}
                  value={caseInformation?.dept}
                  styles={{
                    popup: { root: { maxHeight: 400, overflow: "auto" } },
                  }}
                  treeData={ksList}
                  placeholder="请选择科室"
                  treeDefaultExpandAll
                  onChange={(value) => {
                    setCaseInformation({ ...caseInformation, dept: value });
                    if (value && value.length > 0) {
                      setKeshiStatus(false);
                      return;
                    }
                    setKeshiStatus(true);
                  }}
                  multiple
                  maxCount={5}
                  size="large"
                  showSearch
                  treeNodeFilterProp="title"
                  fieldNames={{
                    value: "key",
                  }}
                />
                {keshiStatus && (
                  <div className="cg-field-error">请选择科室</div>
                )}
              </div>
            </div>

            <div>
              <TextareaField
                label="作品简介"
                indicator="required"
                status={introductionStatus}
                errors={introductionErrorText}
              >
                <textarea
                  value={caseInformation?.description}
                  placeholder="请输入内容"
                  required
                  onChange={(e) => {
                    setCaseInformation({
                      ...caseInformation,
                      description: e.target.value,
                    });
                    if (!e.target.value) {
                      setIntroductionStatus("error");
                      return;
                    }
                    setIntroductionStatus("none");
                  }}
                  maxLength={150}
                ></textarea>
              </TextareaField>
            </div>
          </div>
        )}

        {stepActive === "2" && (
          <div className="third step-content-second">
            <div className="header">
              <span className="label">上传作品附件</span>
              <div className="cg-field-required-indicator">
                <span aria-hidden="true">*</span>
              </div>
            </div>

            <div className="sub-header">
              支持格式：.pdf .ppt .pptx .doc .docx，单个文件不能超过100MB
            </div>

            <div className="upload-file-box">
              <Upload {...fileProps} action={filePropsAction}>
                <ButtonField mode={"ghost"} iconPosition={"left"}>
                  <button type="button">
                    <Iconsvg name="upload-line"></Iconsvg>添加作品
                  </button>
                </ButtonField>
              </Upload>
            </div>

            <div className="header second-header">
              <span className="label">选择展示作品图片</span>
              <div className="cg-field-required-indicator">
                <span aria-hidden="true">*</span>
              </div>
            </div>

            <div className="upload-fileImg-box">
              {caseInformation?.imgUrl &&
                caseInformation?.imgUrl?.map((item, index) => {
                  return (
                    <div className="img-box" key={index}>
                      <RViewerJS>
                        <img src={item} alt="" />
                      </RViewerJS>

                      <div
                        className="delete"
                        onClick={() => {
                          let cloneCaseInformation = cloneDeep(caseInformation);
                          cloneCaseInformation.imgUrl.splice(index, 1);
                          setCaseInformation(cloneCaseInformation);
                        }}
                      >
                        <Iconsvg
                          name="trash"
                          size={16}
                          color="#353535"
                        ></Iconsvg>
                      </div>
                    </div>
                  );
                })}

              <Upload {...fileImgProps}>
                {caseInformation?.imgUrl?.length >= 2 ? null : (
                  <div className="upload-fileImg-btn">
                    <Iconsvg name="photo" size={28}></Iconsvg>
                    <div className="text">上传图片</div>
                  </div>
                )}
              </Upload>
            </div>
          </div>
        )}

        {stepActive === "3" && (
          <div className="third step-content-third">
            <div className="header">第一作者 (必填)</div>

            <div className="author-info">
              <div>
                <InputField label="手机号" indicator="required">
                  <input type="text" value={userInfo?.phone} readOnly />
                </InputField>

                <InputField
                  label="作者名称"
                  indicator="required"
                  status={userNameStatus}
                  errors={usernameErrorText}
                >
                  <input
                    type="text"
                    placeholder="请输入作者名称"
                    required
                    value={userInfo?.userName}
                    onChange={(e) => {
                      setUserInfo({ ...userInfo, userName: e.target.value });
                      if (!e.target.value || e.target.value.length < 2) {
                        setUserNameStatus("error");
                        return;
                      }

                      setUserNameStatus("none");
                    }}
                    maxLength={16}
                    minLength={2}
                  />
                </InputField>
              </div>

              <div>
                {/* <SelectField label="医院">
                  <select
                    value={userInfo?.hospital || ""}
                    onChange={(e) => {
                      setUserInfo({ ...userInfo, hospital: e.target.value });
                    }}
                  >
                    <option disabled hidden value={""}>
                      请选择医院
                    </option>
                    {yyList.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.itemText}
                        </option>
                      );
                    })}
                  </select>
                </SelectField> */}

                <Combobox
                  isOpen={isYyUserDropdownOpen}
                  hasClearButton={
                    isYyUserDropdownOpen && yyUserComboboxInputValue
                  }
                  onDropdownUserRequest={(event) => {
                    setIsYyUserDropdownOpen(event);
                    setYyUserComboboxInputValue(yyUserComboboxValue.itemText);
                  }}
                  onClearUserRequest={onUserClear}
                  label="医院"
                >
                  <input
                    placeholder="请选择医院"
                    value={yyUserComboboxInputValue}
                    onClick={onUserInputClick}
                    onInput={(event) => onUserKey(event)}
                    slot="comboboxInput"
                    maxLength={20}
                  />
                  {Object.values(getFilteredOptionsUser()).map((item, idx) => {
                    return (
                      <React.Fragment key={item.id}>
                        <ComboboxSuggestion
                          isSelected={item.id === yyUserComboboxValue.id}
                          onItemClick={() => onUserComboboxValueChange(item)}
                          slot="comboboxSuggestion"
                        >
                          {item.itemText}
                        </ComboboxSuggestion>
                      </React.Fragment>
                    );
                  })}
                </Combobox>

                <div className="department">
                  <div className="header">科室</div>
                  <TreeSelect
                    style={{ width: "100%" }}
                    value={userInfo?.keshi}
                    styles={{
                      popup: { root: { maxHeight: 400, overflow: "auto" } },
                    }}
                    treeData={ksList}
                    placeholder="请选择科室"
                    treeDefaultExpandAll
                    onChange={(value) => {
                      setUserInfo({ ...userInfo, keshi: value });
                    }}
                    multiple
                    maxCount={5}
                    size="large"
                    showSearch
                    treeNodeFilterProp="title"
                    fieldNames={{
                      value: "key",
                    }}
                  />
                </div>
              </div>

              <div>
                <SelectField label="职称">
                  <select
                    value={userInfo?.zhicheng || ""}
                    onChange={(e) => {
                      setUserInfo({ ...userInfo, zhicheng: e.target.value });
                    }}
                  >
                    <option disabled hidden value={""}>
                      请选择职称或职务
                    </option>
                    {zcList.map((item) => {
                      return (
                        <option key={item.id} value={item.id}>
                          {item.itemText}
                        </option>
                      );
                    })}
                  </select>
                </SelectField>

                <InputField
                  label="电子邮箱"
                  labelFor="input-id-1-2"
                  indicator="required"
                  status={emailStatus}
                  errors={emailErrorText}
                >
                  <input
                    type="text"
                    placeholder="请输入电子邮箱"
                    required
                    value={userInfo?.email}
                    onChange={(e) => {
                      setUserInfo({ ...userInfo, email: e.target.value });
                      if (
                        !e.target.value ||
                        e.target.value.length < 6 ||
                        !emailRegex.test(userInfo?.email)
                      ) {
                        setEmailStatus("error");
                        return;
                      }
                      setEmailStatus("none");
                    }}
                    maxLength={100}
                    minLength={6}
                  />
                </InputField>
              </div>
            </div>

            <div
              className="add-second-user"
              onClick={() => {
                if (isAddSecondUser) {
                  setSecondPhoneStatus("none");
                  setSecondUserNameStatus("none");
                  setSecondUserInfo({
                    secondPhone: "",
                    secondUserName: "",
                  });
                  setIsVerifySecondPhone(false);
                }
                setIsAddSecondUser(!isAddSecondUser);
              }}
            >
              {isAddSecondUser ? "删除第二作者" : "新增第二作者"}
            </div>

            {isAddSecondUser && (
              <div className="second-user-box">
                <div className="header">第二作者 (选填)</div>

                <div className="author-info">
                  <div>
                    <div className="second-user-phone">
                      <InputField
                        label="手机号"
                        indicator="required"
                        status={secondPhoneStatus}
                        errors={secondPhoneErrorText}
                      >
                        <input
                          type="text"
                          value={secondUserInfo?.secondPhone}
                          placeholder="请输入手机号"
                          onChange={(e) => {
                            setSecondUserInfo({
                              ...secondUserInfo,
                              secondPhone: e.target.value,
                            });
                            setIsVerifySecondPhone(false);

                            if (
                              !e.target.value &&
                              !secondUserInfo?.secondUserName
                            ) {
                              setSecondPhoneStatus("none");
                              setSecondUserNameStatus("none");
                              return;
                            }

                            if (
                              (!e.target.value &&
                                secondUserInfo?.secondUserName) ||
                              !phoneRegex.test(e.target.value) ||
                              e.target.value === userInfo?.phone
                            ) {
                              setSecondPhoneStatus("error");
                              return;
                            }

                            setSecondPhoneStatus("none");
                          }}
                          maxLength="11"
                        />
                      </InputField>

                      <div
                        className="get-second-user"
                        onClick={getSecondUserInfo}
                      >
                        获取该账号信息
                      </div>
                    </div>

                    <InputField
                      label="作者名称"
                      indicator="required"
                      status={secondUserNameStatus}
                      errors={secondUserNameErrorText}
                    >
                      <input
                        type="text"
                        placeholder="请输入作者名称"
                        required
                        value={secondUserInfo?.secondUserName}
                        onChange={(e) => {
                          setSecondUserInfo({
                            ...secondUserInfo,
                            secondUserName: e.target.value,
                          });

                          if (!e.target.value && !secondUserInfo?.secondPhone) {
                            setSecondPhoneStatus("none");
                            setSecondUserNameStatus("none");
                            return;
                          }

                          if (
                            (!e.target.value && secondUserInfo?.secondPhone) ||
                            e.target.value.length < 2
                          ) {
                            setSecondUserNameStatus("error");
                            return;
                          }

                          setSecondUserNameStatus("none");
                        }}
                        maxLength={16}
                        minLength={2}
                      />
                    </InputField>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="fourth">
          <ButtonField mode={"ghost"}>
            <button type="button" onClick={() => leave()}>
              离开
            </button>
          </ButtonField>

          <div className="flex">
            {(stepActive === "2" || stepActive === "3") && (
              <ButtonField mode={"ghost"}>
                <button
                  type="button"
                  onClick={() => {
                    if (stepActive === "2") {
                      setStepActive("1");
                    } else if (stepActive === "3") {
                      setStepActive("2");
                    }
                  }}
                >
                  上一步
                </button>
              </ButtonField>
            )}

            <ButtonField>
              <button
                type="button"
                onClick={() => {
                  next(stepActive);
                }}
                disabled={
                  isSubmitLoading ||
                  (stepActive === "3" && isSubmissionClosed())
                }
              >
                {stepActive === "3" && isSubmissionClosed()
                  ? "投稿已截止"
                  : stepActive === "3"
                  ? "提交"
                  : "下一步"}
                {isSubmitLoading && (
                  <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                )}
              </button>
            </ButtonField>
          </div>
        </div>
      </div>

      <ModalConfirm
        height="368px"
        isOpen={isCodeOpen}
        onClose={() => {
          setIsCodeOpen(false);
          setFirstCode("");
          setSecondCode("");
          setThirdCode("");
          setForthCode("");
          setIsVerifyError(false);
        }}
        children={
          <div className="modal-body-box">
            <div className="code-box">
              <div className="modal-first">
                需要进行验证码确认，请通过手机接收验证码
              </div>
              <div className="modal-second">
                <div className="title-text">当前账户安全手机:</div>
                <div className="phone-number">{delText}</div>
              </div>

              <div className="modal-third">
                <div className="first-code-number">
                  <InputField isDisabled={isVerifyLoading}>
                    <input
                      ref={codeNumFirstRef}
                      type="text"
                      value={firstCode}
                      onChange={(e) => {
                        setFirstCode(e.target.value);
                        setIsVerifyError(false);
                        if (e.target.value) {
                          codeNumSecondRef.current.focus();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value) {
                          codeNumSecondRef.current.focus();
                        }
                      }}
                      maxLength="1"
                      readOnly={isVerifyLoading}
                    />
                  </InputField>
                </div>
                <div className="second-code-number">
                  <InputField isDisabled={isVerifyLoading}>
                    <input
                      ref={codeNumSecondRef}
                      type="text"
                      value={secondCode}
                      onChange={(e) => {
                        setSecondCode(e.target.value);
                        setIsVerifyError(false);
                        if (e.target.value) {
                          codeNumThirdRef.current.focus();
                        } else {
                          codeNumFirstRef.current.focus();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value) {
                          codeNumThirdRef.current.focus();
                        } else {
                          codeNumFirstRef.current.focus();
                        }
                      }}
                      maxLength="1"
                      readOnly={isVerifyLoading}
                    />
                  </InputField>
                </div>
                <div className="third-code-number">
                  <InputField isDisabled={isVerifyLoading}>
                    <input
                      ref={codeNumThirdRef}
                      type="text"
                      value={thirdCode}
                      onChange={(e) => {
                        setThirdCode(e.target.value);
                        setIsVerifyError(false);
                        if (e.target.value) {
                          codeNumForthRef.current.focus();
                        } else {
                          codeNumSecondRef.current.focus();
                        }
                      }}
                      onInput={(e) => {
                        if (e.target.value) {
                          codeNumForthRef.current.focus();
                        } else {
                          codeNumSecondRef.current.focus();
                        }
                      }}
                      maxLength="1"
                      readOnly={isVerifyLoading}
                    />
                  </InputField>
                </div>
                <div className="fourth-code-number">
                  <InputField isDisabled={isVerifyLoading}>
                    <input
                      ref={codeNumForthRef}
                      type="text"
                      value={forthCode}
                      onChange={(e) => {
                        setForthCode(e.target.value);
                        setIsVerifyError(false);
                        if (!e.target.value) {
                          codeNumThirdRef.current.focus();
                        }
                      }}
                      onInput={(e) => {
                        if (!e.target.value) {
                          codeNumThirdRef.current.focus();
                        }
                      }}
                      maxLength="1"
                      readOnly={isVerifyLoading}
                    />
                  </InputField>
                </div>
              </div>
              {isVerifyError && (
                <div className="cg-field-error">验证码错误</div>
              )}
            </div>
          </div>
        }
        title={"验证码确认"}
        onConfirm={() => getSecondCode()}
        okText={second < 1 ? "重新获取短信" : `${second}秒后重新获取短信`}
        isConfirmLoading={isVerifyLoading || !(second < 1)}
      />

      <ModalConfirm
        isOpen={isUpToDaUserOpen}
        onClose={() => {
          setIsUpToDaUserOpen(false);
        }}
        children={
          <div className="modal-body-text">更新个人信息并提交案例?</div>
        }
        title={"操作确认"}
        onConfirm={() => {
          UpToDateAndEdit();
        }}
        okText="确认"
      />

      <ModalConfirm
        isOpen={isUploadOpen}
        onClose={() => {
          setIsUploadOpen(false);
        }}
        children={<div className="modal-body-text">{uploadErrorText}</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsUploadOpen(false);
        }}
        okText="确认"
      />

      <ModalConfirm
        height="auto"
        isOpen={isQrCodeOpen}
        onClose={() => {
          setIsQrCodeOpen(false);
          navigate("/player/personalCases");
        }}
        onCancel={() => {
          copyLink(qrCodeText);
        }}
        children={
          <div className="modal-body-qrCode">
            <img src={qrCodeUrl} alt="" title="" />
            <div className="modal-body-qrCode-text">扫码激活第二作者账号</div>
          </div>
        }
        title={"扫描二维码"}
        onConfirm={() => {
          const downloadLink = document.createElement("a");
          downloadLink.style.display = "none";
          downloadLink.href = qrCodeUrl;
          downloadLink.download = "激活码";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        }}
        okText="下载图片"
        cancelText="复制激活链接"
        isConfirmLoading={isdownloadImg}
      />

      <ModalConfirm
        isOpen={isSaveOpen}
        onClose={() => {
          setIsSaveOpen(false);
        }}
        children={<div className="modal-body-text">是否保存该步骤的内容?</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsSaveOpen(false);
          leaveSave();
        }}
        onCancel={() => {
          setIsSaveOpen(false);

          navigate("/player/personalCases");
        }}
        okText="是"
        cancelText="否"
        isConfirmLoading={isSubmitLoading}
      />

      <AddYyModal
        nameValue={
          stepActive == "1"
            ? yyComboboxInputValue
            : stepActive == "3"
            ? yyUserComboboxInputValue
            : ""
        }
        isOpen={isAddYyOpen}
        onClose={() => {
          setIsAddYyOpen(false);
        }}
        title="添加机构"
        onConfirm={(value, callBack) => {
          addYy(value, callBack);
        }}
        isConfirmLoading={isAddYyLoading}
        height="auto"
        okText="提交"
      />

      <ModalConfirm
        isOpen={isValueError}
        onClose={() => {
          setIsValueError(false);
        }}
        children={
          <div className="modal-body-text">数据值不可用，系统中已存在！</div>
        }
        title={"操作确认"}
        onConfirm={() => {
          setIsValueError(false);
        }}
        okText="确定"
      />

      <ModalConfirm
        isOpen={isMessageOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        children={<div className="modal-body-text">{messageText}</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        okText="确认"
      />
    </div>
  );
};
export default AddSubmission;
